const state = {
  loading: false
}

const getters = {
  systemLoading: state => state.loading
}

const actions = {
  setLoading ({ commit }) {
    commit('setLoading')
  },
  unsetLoading ({ commit }) {
    commit('unsetLoading')
  }
}

const mutations = {
  setLoading (state) {
    state.loading = true
  },
  unsetLoading (state) {
    state.loading = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/utils.js